<template>
  <v-app id="dashboard">
    <navigation></navigation>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col cols="md-4">
            <v-sheet rounded="" outlined class="pa-6">
              <h4 class="pt-4 pb-2">{{ team.name }}</h4>
              <v-divider></v-divider>
              <div class="px-4 py-6">
                <v-icon size="32" class="mr-2">mdi-eye</v-icon>
                {{ users.length }} Team-Mitglieder
              </div>
              <v-btn color="primary" width="100%" @click.stop="new_user_dialog=true" depressed>Mitglied hinzufügen
              </v-btn>
            </v-sheet>
          </v-col>
          <v-col cols="md-8">
            <v-sheet min-height="100%" rounded="" outlined class="pa-6">
              <h4 class="py-2">Team Mitglieder</h4>
              <v-divider></v-divider>
              <v-simple-table>
                <template v-slot:default>
                  <!-- <thead>
                            <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left"></th>
                            <th class="text-left"></th>
                            <th class="text-left"></th>
                            <th class="text-left"></th>
                            </tr>
                        </thead> -->

                  <tbody>
                  <tr v-for="user in users" :key="user.uid">
                    <td class="text-body-1 pl-0">
                      {{ user.first_name }} {{ user.last_name }}
                      <span v-if="me.uid === user.uid">(du)</span>
                    </td>
                    <td class="text-caption px-0 mr-0" width="6%">
                      <v-btn
                          v-if="me.uid !== user.uid && user.team_relation.role!==3"
                          style="border-radius: 5px"
                          small
                          color="primary"
                          icon
                          outlined
                          :href="user.public_profile_url"
                          target="_blank"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn
                      >
                    </td>
                    <td class="text-caption px-0" width="6%">
                      <v-btn
                          v-if="me.uid !== user.uid"
                          style="border-radius: 5px"
                          small
                          color="primary"
                          icon
                          outlined
                          @click="openEditDialog(user)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn
                      >
                    </td>
                    <td class="text-caption px-0" width="6%">
                      <v-btn
                          v-if="me.uid !== user.uid"
                          style="border-radius: 5px"
                          small
                          color="primary"
                          icon
                          outlined
                          @click="openConfirmDelete(user)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn
                      >
                    </td>
                  </tr>
                  <tr v-for="user in (team.invited || [])" :key="user.email || user.id">
                    <td class="text-body-1 pl-0" colspan="1">{{ user.email }}</td>
                    <td class="text-body-1 pl-0 text-right" colspan="2">
                      <v-chip color="yellow" label>Eingeladen</v-chip>
                    </td>
                    <td class="text-caption px-0" width="6%">
                      <v-btn
                          v-if="me.uid !== user.uid"
                          style="border-radius: 5px"
                          small
                          color="primary"
                          icon
                          outlined
                          @click="openConfirmDelete(user)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn
                      >
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-alert
                  dense
                  border="left"
                  type="warning"
                  class="black--text my-4"
              >
                Kontaktaufnahme mit Wocodea Support ->
                Weiterleitung bei Pensionierung, Beendigung des Dienstverhältnisses oder Änderung des Kund*innenstamms
              </v-alert>

            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="confirmDeleteDialog" width="500" :retain-focus="false">
      <v-card>
        <v-card-title class="subtitle grey lighten-2">
          Bist du sicher?
        </v-card-title>
        <v-card-text class="pt-4">
          Möchtest du das Team-Mitglied
          <strong>
            {{ confirmDeleteDialogUser.first_name }} {{ confirmDeleteDialogUser.last_name }}
          </strong>
          wirklich löschen?
        </v-card-text>
        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <h2>Nachfolger bestimmen</h2>
          <p class="ma-0">Wähle an wen die Aufrufe des Profils von
            <strong>{{ confirmDeleteDialogUser.first_name }} {{ confirmDeleteDialogUser.last_name }}</strong>
            werden weitergeleitet werden sollen.</p>
        </v-card-text>

        <v-select
            :items="filteredUsers"
            v-model="selected_user"
            item-text="name"
            item-value="id"
            background-color="grey lighten-3"
            return-object
            placeholder="Nachfolger auswählen"
            class="mx-6 border-1"
            flat
            solo
        ></v-select>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="disabled"
              @click="confirmDeleteDialog = false"
              text
          >Abbrechen
          </v-btn
          >
          <v-btn color="primary" @click="deleteUser">
            Ja, löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="new_user_dialog" width="500" :retain-focus="false">
      <v-card>
        <v-card-title class="subtitle grey lighten-2">
          Neues Team-Mitglied
        </v-card-title>

        <v-card-text class="pt-4">
          <v-form>
            <span class="caption"><strong>Vorname</strong></span>
            <v-text-field v-model="new_user.first_name" solo flat outlined></v-text-field>
            <span class="caption"><strong>Nachname</strong></span>
            <v-text-field v-model="new_user.last_name" solo flat outlined></v-text-field>
            <span class="caption"><strong>Email-Adresse</strong></span>
            <v-text-field v-model="new_user.email" solo flat outlined></v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn
              color="disabled"
              @click="new_user_dialog = false"
              text
          >Abbrechen
          </v-btn
          >
          <v-btn color="primary" @click="addUser">
            Einladen


          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_user_dialog" width="1000" :retain-focus="false">
      <v-card>
        <v-card-title class="subtitle grey lighten-2">
          Team-Mitglied bearbeiten
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="md-6">
              <v-card-text class="pt-4">
                <v-form>
                  <span class="caption"><strong>Vorname</strong></span>
                  <v-text-field v-model="edit_user.first_name" solo flat outlined></v-text-field>
                  <span class="caption"><strong>Nachname</strong></span>
                  <v-text-field v-model="edit_user.last_name" solo flat outlined></v-text-field>
                  <span class="caption"><strong>Email-Adresse</strong></span>
                  <v-text-field v-model="edit_user.email" solo flat outlined></v-text-field>
                  <span class="caption"><strong>Website</strong></span>
                  <v-text-field v-model="edit_user.url" solo flat outlined></v-text-field>
                  <span class="caption"><strong>Position</strong></span>
                  <v-text-field v-model="edit_user.title" solo flat outlined></v-text-field>
                  <span class="caption"><strong>YouTube-Link</strong></span>
                  <v-text-field v-model="edit_user.about_video" solo flat outlined></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-text class="pt-4">
                <v-form v-if="edit_user.role !== 2">
                  <p class="mb-2"><strong>Role</strong></p>

                  <v-radio-group v-model="edit_user.role" row>
                    <v-radio label="Regular" :value="1"></v-radio>
                    <v-radio label="Marketing" :value="3"></v-radio>
                  </v-radio-group>

                </v-form>
              </v-card-text>
            </v-col>
            <v-col cols="md-6">
              <v-card-text class="pt-4">
                <v-form>
                  <span class="caption"><strong>Telefon</strong></span>
                  <v-text-field v-model="edit_user.phone" solo flat outlined></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-text class="pt-0">
                <v-form>
                  <span class="caption"><strong>Über mich</strong></span>
                  <v-textarea v-model="edit_user.about_text" solo flat outlined></v-textarea>
                </v-form>
              </v-card-text>

              <v-card-text class="py-0">
                <v-form>
                  <img class="preview" v-if="edit_user.avatar_src" :src="edit_user.avatar_src" />
                  <span class="caption"><strong>Profilbild</strong></span>
                  <v-file-input
                      v-model="edit_user.avatar"
                      accept="image/*"
                      label="Upload image"
                      outlined
                      dense
                      prepend-icon="mdi-camera"
                      @change="uploadAvatar"
                  ></v-file-input>
                </v-form>
              </v-card-text>

              <v-card-text class="py-0">
                <v-form>
                  <img class="preview" v-if="edit_user.about_image_src" :src="edit_user.about_image_src" />
                  <span class="caption"><strong>Zusätzliches Bild</strong></span>
                  <v-file-input
                      v-model="edit_user.about_image"
                      accept="image/*"
                      label="Upload about image"
                      outlined
                      dense
                      prepend-icon="mdi-camera"
                      @change="uploadAboutImage"
                  ></v-file-input>
                </v-form>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="disabled"
              @click="edit_user_dialog = false"
              text
          >Abbrechen
          </v-btn
          >
          <v-btn color="primary" @click="editUser">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        top
        right
    >
      {{ snackbar.text }}
      <v-btn text @click="snackbar.show = false">Schließen</v-btn>
    </v-snackbar>

  </v-app>
</template>
<style scoped>
.preview {
  margin-top: 16px;
  max-width: 80px;
  max-height: 80px;
  margin-left: 20px;
  float: right;
  background: #ccc;
}
</style>
<script>
import navigation from './Navigation.vue'
import axios from 'axios'

export default {
  components: {
    navigation: navigation
  },
  data: () => ({
    team_name: "Team Name",
    me: {uid: 0, firstname: "Daniel", lastname: "Düsentrieb"},
    new_user_dialog: false,
    new_user: {},
    edit_user_dialog: false,
    edit_user: {},
    confirmDeleteDialog: false,
    confirmDeleteDialogUser: {},
    modalData: {},
    loading: false,
    selected_user: null,
    snackbar: {
      show: false,
      text: '',
      color: 'success',
      timeout: 3000,
    },
  }),
  mounted() {
    // this.users = this.$store.getters.members
    if (this.$store.getters.members.length == 0) {
      this.$store.dispatch('getTeam', {})
    }
  },
  computed: {
    users() {
      return this.$store.getters.members
    },
    // invited () {
    //   return this.$store.getters.team.invited
    // },
    team() {
      return this.$store.getters.team
    },
    filteredUsers() {
      if (!this.confirmDeleteDialogUser?.id) return this.users;

      return this.users.filter(
          u => u.id !== this.confirmDeleteDialogUser.id
      );
    }
  },
  methods: {
    openConfirmDelete(user) {
      this.confirmDeleteDialogUser = user
      this.confirmDeleteDialog = true
    },
    openEditDialog(user) {
      this.edit_user = user
      this.edit_user.role = this.edit_user.team_relation.role
      this.edit_user_dialog = true
    },
    async deleteUser() {
      this.confirmDeleteDialog = false
      try {
        await this.$store.dispatch('deleteMember', { id: this.confirmDeleteDialogUser.id, successor_id: this.selected_user ? this.selected_user.id : '' })
        await this.$store.dispatch('getTeam', {})
        this.selected_user = null;
      } catch (error) {
        console.error('error deleting user. ', error)
      }
    },
    async addUser() {
      this.new_user = {
        first_name: this.new_user.first_name,
        last_name: this.new_user.last_name,
        email: this.new_user.email
      }
      this.loading = true
      try {
        await this.$store.dispatch('addMember', this.new_user)
        await this.$store.dispatch('getTeam', {})
        this.new_user_dialog = false
        this.new_user = {}
      } catch (error) {
        const msg = (error && error.message) ? error.message : 'Mitglied konnte nicht eingeladen werden.'
        alert(msg)
        console.error('Error adding user.', error)
      }
      this.loading = false
    },
    async editUser() {
      try {
        await this.$store.dispatch('updateMember', this.edit_user)
        await this.$store.dispatch('getTeam', {})
        this.edit_user_dialog = false
        this.showToast(`Benutzer wurde aktualisiert`);
      } catch (error) {
        alert('Änderung konnte nicht gespeichert werden.')
        console.error('Error updating user. ', error)
      }
    },
    async uploadAvatar(file) {
      if (!file) return;

      const formData = new FormData();
      formData.append('avatar', file);
      formData.append('user_id', this.edit_user.id);

      try {
        const response = await axios.post(
            process.env.VUE_APP_API_URL + '/api/v1/user/image',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        );
        this.showToast(`Benutzer wurde aktualisiert`);
      } catch (error) {
        console.error('Avatar upload failed', error);
      }
    },
    async uploadAboutImage(file) {
      if (!file) return;

      const formData = new FormData();
      formData.append('about_image', file);
      formData.append('user_id', this.edit_user.id);

      try {
        const response = await axios.post(
            process.env.VUE_APP_API_URL + '/api/v1/user/image',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        );
        this.showToast(`Benutzer wurde aktualisiert`);
      } catch (error) {
        console.error('Avatar upload failed', error);
      }
    },
    showToast(message, color = 'success') {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

  }
};
</script>

<style lang="scss">
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>